import { Box, Button, IconButton, TextField, Typography } from "@mui/material"
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import { BrandModel } from "../../models/brand";
import useFormBrandController from "./controller/form";
import ConfirmDialog from "../../components/ConfirmDialog";
import { useTranslation } from "react-i18next";


interface Props {
    onClose: VoidFunction
    selectedData: BrandModel
    selectedValue: Function
    onFetchData: Function
}

const FormBrandView = ({ onClose, selectedData, selectedValue, onFetchData }: Props) => {
    const controller = useFormBrandController({ selectedData, selectedValue, onFetchData, onClose })
    const { t } = useTranslation('global')


    return (
        <Box>
            <IconButton onClick={() => { onClose(); controller.handleResetForm() }} sx={{ mb: 2 }}>
                <KeyboardBackspaceIcon />
            </IconButton>
            <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight="bold">{selectedData ? "ເເກ້ໄຂພະລິດຕະພັນ" : "ສ້າງພະລິດຕະພັນ"}</Typography>
            <form onSubmit={(e) => controller.handleOpenConfirmForm(e)}>
                <Box
                    sx={{
                        p: 5,
                        width: '40%',
                        height: "35vh",
                        mt: 2,
                        borderRadius: '15px',
                        boxShadow:
                            '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                    }}
                >
                    <Box sx={{ width: '100%' }}>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold">ຊື່ພາສາອັງກິດ</Typography>
                        <TextField fullWidth size="small" margin="normal" required inputRef={controller.nameEng} />
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <Typography color={TEXT_TITLE_COLOR} fontWeight="bold">ຊື່ພາສາລາວ</Typography>
                        <TextField fullWidth size="small" margin="normal" required inputRef={controller.nameLao} />
                    </Box>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'end' }}>
                        <Button type='submit' variant="contained" sx={{ textTransform: 'none', borderRadius: '10px', background: '#11A2F1' }}>
                            {selectedData ? t("Update") : t("Create")}
                        </Button>
                    </Box>
                </Box>
                <ConfirmDialog
                    open={controller.openConfirm}
                    title={`${selectedData ? "Do yo want to Update this Data ?" : "Do you want to Create this Data ?"}`}
                    loading={controller.loadingButton}
                    onCancel={controller.handleCloseConfirm}
                    onConfirm={() => controller.handleSubmit()}
                />
            </form>
        </Box>
    )
}
export default FormBrandView